import { render, staticRenderFns } from "./ServiceDay.vue?vue&type=template&id=da24dac6&"
import script from "./ServiceDay.vue?vue&type=script&lang=js&"
export * from "./ServiceDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports